import setup from './setup';
import { setBrowserTimezone } from './utils';

function students(): void {
  setBrowserTimezone();
  window.addEventListener('load', setup);
}

export default students;
